import {ContainerModule} from '@yosmanyga/di';

import {
    AppDeviceController,
    AppLanguageController,
    AppTranslationController,
    AppUnreadFeedbackController,
    BuyController,
    FeedbackController,
    HelpController,
    IntroductionController,
    MapController,
    NotesController,
    PlayBoardController,
    PlayInputController,
    PlayInputNotePromptController,
    PlayNoteController,
    ProfileController,
    RestartController,
    RestorationListController,
    RestorationPromptController,
    WithLanguageController,
} from './';

const DI = new ContainerModule((bind) => {
    bind(PlayBoardController).toSelf();
    bind(PlayInputController).toSelf();
    bind(PlayInputNotePromptController).toSelf();
    bind(PlayNoteController).toSelf();
    bind(RestorationListController).toSelf();
    bind(RestorationPromptController).toSelf();
    // bind(AppCredentialController).toSelf().inSingletonScope();
    bind(AppDeviceController).toSelf();
    bind(AppLanguageController).toSelf();
    bind(AppTranslationController).toSelf();
    bind(AppUnreadFeedbackController).toSelf();
    bind(BuyController).toSelf();
    bind(FeedbackController).toSelf();
    bind(HelpController).toSelf();
    bind(IntroductionController).toSelf();
    bind(MapController).toSelf();
    bind(NotesController).toSelf();
    bind(ProfileController).toSelf();
    bind(RestartController).toSelf();
    bind(WithLanguageController).toSelf();
});

export {DI};
